<ion-header>
    <ion-toolbar class="cookies-header">
        <ion-title>Política Cookies</ion-title>
        <ion-buttons slot="end" (click)="dismissModal()">
            <ion-icon name="close"></ion-icon>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
  
<section class="cookies-policy">
  <p>
    En cumplimiento con lo dispuesto en el artículo 22.2 de la Ley 34/2002, de 11 de julio, de Servicios de la
    Sociedad de la Información y de Comercio Electrónico, esta página web le informa, en esta sección, sobre la
    política de recogida y tratamiento de cookies.
  </p>

  <h4>Qué son las cookies y para qué se utilizan</h4>

  <p>
    La palabra cookies es el término inglés que se utiliza para denominar los pequeños ficheros de texto que se
    descargan en el navegador del equipo (ordenador, teléfono móvil, <em>tablet</em>…) de un usuario al navegar en un
    sitio web, aplicación o plataforma informática.
  </p>

  <p>
    Las cookies aportan grandes ventajas en la prestación de servicios de la sociedad de la información, ya que
    facilitan y agilizan la navegación por internet, y también nos ayudan a mejorar la calidad de los servicios que
    prestamos a nuestros usuarios. Las cookies, entre otras cosas, permiten almacenar y recuperar información sobre
    los hábitos de navegación de un usuario o de su equipo, lo que nos sirve para conocer qué páginas o utilidades de
    un sitio web, aplicación o plataforma son más útiles y cuáles no, a efectos de mejorarlas y, dependiendo de la
    información que contengan y de la forma en la que utilice su equipo, también pueden utilizarse para reconocer al
    usuario.
  </p>

  <h4>Tipo de cookies que utilizamos en esta web</h4>

  <p class="section-label">Según la entidad que las gestiona</p>
  <ul>
    <li>
      <strong>Cookies propias</strong>: las que enviamos al equipo del usuario desde un equipo o dominio gestionado por
      la Empresa Municipal de Transportes de Madrid y desde el que se presta el servicio solicitado por el usuario.
    </li>
  </ul>

  <p class="section-label">Según el plazo de tiempo que permanecen activas</p>
  <ul>
    <li>
      <strong>Cookies de sesión</strong>: son temporales y permanecen en el navegador del equipo del usuario hasta que
      abandona la web, aplicación o plataforma. Estas cookies permiten facilitar y agilizar la navegación.
    </li>
  </ul>

  <p class="section-label">Según su finalidad</p>
  <ul>
    <li>
      <strong>Cookies técnicas</strong>: son las que permiten al usuario la navegación a través de un sitio web,
      aplicación o plataforma.
    </li>
  </ul>

  <p>
    Se ofrece a continuación un listado con información detallada de las cookies que se utilizan en el sitio web
    <span class="mono">https://emt.ciceroneweb.com</span>:
  </p>

  <div class="table-wrapper">
    <table class="cookies-table">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Tipo</th>
          <th>Caducidad</th>
          <th>Proveedor</th>
          <th>Descripción</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>cookie-agreed</td>
          <td>Necesaria y técnica</td>
          <td>100 días</td>
          <td>Propias</td>
          <td>Permite al sistema saber si se ha aceptado la política de cookies</td>
        </tr>
        <tr>
          <td>cookie-agreed-version</td>
          <td>Necesaria y técnica</td>
          <td>101 días</td>
          <td>Propias</td>
          <td>Permite al sistema saber la versión de la política de cookies aceptada</td>
        </tr>
      </tbody>
    </table>
  </div>

  <h4>Información adicional sobre el Tratamiento de Datos</h4>

  <p>
    Para disponer de más información sobre los tratamientos de sus datos personales que se realizan a través de la
    página web puede consultar nuestra política de privacidad.
  </p>

  <p>Tal como se detalla en la citada política, el Responsable del Tratamiento de sus datos es:</p>

  <ul>
    <li>Empresa Municipal de Transportes de Madrid, S.A. (“EMT”)</li>
    <li>N.I.F.: A28046316</li>
    <li>Calle Cerro de la Plata, 4. 28007. Madrid</li>
  </ul>

  <p>
    Si tiene cualquier duda sobre el tratamiento de su información personal, puede contactar con el Delegado de
    Protección de Datos de la EMT, mediante los siguientes datos de contacto:
  </p>

  <ul>
    <li>
      Correo electrónico:
      <a href="mailto:proteccion.datos&#64;emtmadrid.es">proteccion.datos&#64;emtmadrid.es</a>
    </li>
    <li>
      Correo postal: Calle Cerro de la Plata, 4. 28007. Madrid. En atención a: Dirección cumplimiento normativo.
      Servicio Delegado de Protección de Datos
    </li>
  </ul>

  <h4>Administrar cookies</h4>

  <p>
    Usted puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las
    opciones del navegador instalado en su equipo.
  </p>

  <p>
    En la mayoría de los navegadores web se ofrece la posibilidad de permitir, bloquear o eliminar las cookies
    instaladas en su equipo.
  </p>

  <p>
    A continuación, le mostramos enlaces a instrucciones a través de las cuales usted puede acceder a la configuración
    de los navegadores webs más frecuentes para aceptar, instalar o desactivar las cookies:
  </p>

  <ul>
    <li>
      <a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener">
        Configurar cookies en Google Chrome
      </a>
    </li>
    <li>
      <a
        href="https://support.microsoft.com/es-es/windows"
        target="_blank"
        rel="noopener"
      >
        Configurar cookies en Microsoft Internet Explorer
      </a>
    </li>
    <li>
      <a
        href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
        target="_blank"
        rel="noopener"
      >
        Configurar cookies en Mozilla Firefox
      </a>
    </li>
    <li>
      <a href="https://support.apple.com/es-es/HT201265" target="_blank" rel="noopener">
        Configurar cookies en Safari (Apple)
      </a>
    </li>
  </ul>

  <h4>Transferencias de datos a terceros países</h4>

  <p>La EMT no realiza transferencias de datos a terceros países respecto a las cookies instaladas desde sus dominios.</p>

  <h4>Advertencia sobre eliminar cookies</h4>

  <p>
    Usted puede eliminar y bloquear todas las cookies de este sitio, pero parte del sitio no funcionará o la calidad de
    la página web puede verse afectada.
  </p>

  <p>
    Si tiene cualquier duda acerca de nuestra política de cookies, puede contactar con esta página web a través de
    nuestros canales de contacto
  </p>
</section>